/**
 * UI
 */
export const SET_RESPONSIVE_HEADER_VIEW = 'app/SET_RESPONSIVE_HEADER_VIEW';
export const SET_RESPONSIVE_CONTENT_VIEW = 'app/SET_RESPONSIVE_CONTENT_VIEW';
export const TOGGLE_INFO_MODAL = 'app/TOGGLE_INFO_MODAL';
export const SET_MOBILE_BROWSER = 'app/SET_MOBILE_BROWSER';
export const SET_DEVICE_ORIENTATION = 'app/SET_DEVICE_ORIENTATION';
export const SET_LOADING_MODAL = 'app/SET_LOADING_MODAL';

/**
 * Init
 */
export const FETCH_INIT_DATA_REQUEST = 'app/FETCH_INIT_DATA_REQUEST';
export const FETCH_INIT_DATA_SUCCESS = 'app/FETCH_INIT_DATA_SUCCESS';
export const FETCH_INIT_DATA_FAILURE = 'app/FETCH_INIT_DATA_FAILURE';

/**
 * Profile
 */
export const UPDATE_USER_PASSWORD_REQUEST = 'app/UPDATE_USER_PASSWORD_REQUEST';
export const UPDATE_USER_PASSWORD_SUCCESS = 'app/UPDATE_USER_PASSWORD_SUCCESS';
export const UPDATE_USER_PASSWORD_FAILURE = 'app/UPDATE_USER_PASSWORD_FAILURE';

export const UPDATE_USER_PROFILE_REQUEST = 'app/UPDATE_USER_PROFILE_REQUEST';
export const UPDATE_USER_PROFILE_SUCCESS = 'app/UPDATE_USER_PROFILE_SUCCESS';
export const UPDATE_USER_PROFILE_FAILURE = 'app/UPDATE_USER_PROFILE_FAILURE';

export const UPDATE_2FA_SETTINGS_REQUEST = 'app/UPDATE_2FA_SETTINGS_REQUEST';
export const UPDATE_2FA_SETTINGS_SUCCESS = 'app/UPDATE_2FA_SETTINGS_SUCCESS';
export const UPDATE_2FA_SETTINGS_FAILURE = 'app/UPDATE_2FA_SETTINGS_FAILURE';

export const UPDATE_USER = 'app/UPDATE_USER';

export const SEND_PHONE_NUM_VERIF_CODE_REQUEST =
  'app/SEND_PHONE_NUM_VERIF_CODE_REQUEST';

export const SEND_TOTP_VERIF_CODE_REQUEST = 'app/SEND_TOTP_VERIF_CODE_REQUEST';

export const GET_USER_DATA = 'app/GET_USER_DATA';
export const SET_USER_DATA = 'app/SET_USER_DATA';

/**
 * Device
 */
export const SET_CAMERA_STREAM_REQUEST = 'app/SET_CAMERA_STREAM_REQUEST';
export const SET_CAMERA_STREAM_SUCCESS = 'app/SET_CAMERA_STREAM_SUCCESS';

export const ENUMERATE_DEVICES_REQUEST = 'app/ENUMERATE_DEVICES_REQUEST';
export const ENUMERATE_DEVICES_SUCCESS = 'app/ENUMERATE_DEVICES_SUCCESS';

/**
 * Email change
 */
export const CHANGE_EMAIL_REQUEST = 'app/CHANGE_EMAIL_REQUEST';
export const CHANGE_EMAIL_SUCCESS = 'app/CHANGE_EMAIL_SUCCESS';
export const CHANGE_EMAIL_FAILURE = 'app/CHANGE_EMAIL_FAILURE';
export const UPDATE_EMAIL_ADDRESS = 'app/UPDATE_EMAIL_ADDRESS';

export const VERIFY_EMAIL_CODE_REQUEST = 'app/VERIFY_EMAIL_CODE_REQUEST';
export const VERIFY_EMAIL_CODE_SUCCESS = 'app/VERIFY_EMAIL_CODE_SUCCESS';
export const VERIFY_EMAIL_CODE_FAILURE = 'app/VERIFY_EMAIL_CODE_FAILURE';

/**
 * Phone number change
 */
export const CHANGE_PHONE_NUMBER_REQUEST = 'app/CHANGE_PHONE_NUMBER_REQUEST';
export const CHANGE_PHONE_NUMBER_SUCCESS = 'app/CHANGE_PHONE_NUMBER_SUCCESS';
export const CHANGE_PHONE_NUMBER_FAILURE = 'app/CHANGE_PHONE_NUMBER_FAILURE';

export const VERIFY_PHONE_NUMBER_CODE_REQUEST =
  'app/VERIFY_PHONE_NUMBER_CODE_REQUEST';
export const VERIFY_PHONE_NUMBER_CODE_SUCCESS =
  'app/VERIFY_PHONE_NUMBER_CODE_SUCCESS';
export const VERIFY_PHONE_NUMBER_CODE_FAILURE =
  'app/VERIFY_PHONE_NUMBER_CODE_FAILURE';

/**
 * KYC
 */
export const FETCH_KYC_STATUS_REQUEST = 'app/FETCH_KYC_STATUS_REQUEST';
export const FETCH_KYC_STATUS_SUCCESS = 'app/FETCH_KYC_STATUS_SUCCESS';
export const FETCH_KYC_STATUS_FAILURE = 'app/FETCH_KYC_STATUS_FAILURE';

export const UPLOAD_KYC_DOCUMENT_REQUEST = 'app/UPLOAD_KYC_DOCUMENT_REQUEST';
export const UPLOAD_KYC_DOCUMENT_SUCCESS = 'app/UPLOAD_KYC_DOCUMENT_SUCCESS';
export const UPLOAD_KYC_DOCUMENT_FAILURE = 'app/UPLOAD_KYC_DOCUMENT_FAILURE';

export const DELETE_KYC_DOCUMENT_REQUEST = 'app/DELETE_KYC_DOCUMENT_REQUEST';
export const DELETE_KYC_DOCUMENT_SUCCESS = 'app/DELETE_KYC_DOCUMENT_SUCCESS';
export const DELETE_KYC_DOCUMENT_FAILURE = 'app/DELETE_KYC_DOCUMENT_FAILURE';

export const CANCEL_KYC_VERIFICATION_REQUEST =
  'app/CANCEL_KYC_VERIFICATION_REQUEST';
export const CANCEL_KYC_VERIFICATION_SUCCESS =
  'app/CANCEL_KYC_VERIFICATION_SUCCESS';
export const CANCEL_KYC_VERIFICATION_FAILURE =
  'app/CANCEL_KYC_VERIFICATION_FAILURE';
